export default "__VITE_ASSET__qDG4KwR0__"